const groupRows = (columns, rows) => {
    const groupByColumns = columns
        .filter((c) => c.footer)
        .filter((c) => c.footer.groupBy);

    return rows.reduce((result, row) => {
        const key = groupByColumns.map((c) => row[c.key]).join("#");
        if (!result[key]) {
            result[key] = [];
        }
        result[key].push(row);
        return result;
    }, []);
};

const sumRows = (columns, groups, t) =>
    Object.values(groups).reduce((groupResult, rows) => {
        const groupSum = columns.reduce((sumResult, column, index) => {
            if (!column.footer && index === 0) {
                sumResult[column.key] = t.sum;
            } else if (!column.footer) {
                sumResult[column.key] = "";
            } else if (column.footer.groupBy) {
                sumResult[column.key] = rows[0][column.key];
            } else if (column.footer.sum) {
                let sum;

                if (column.key === "totalAmount") {
                    const seenInvoices = new Set();
                    const filteredRows = rows.filter((row) => {
                        // Invoice object has inconsistent id field in different places
                        if (row.invoiceId && !seenInvoices.has(row.invoiceId)) {
                            seenInvoices.add(row.invoiceId);
                            return true;
                        }

                        // Invoice object has inconsistent id field in different places
                        if (row.id && !seenInvoices.has(row.id)) {
                            seenInvoices.add(row.id);
                            return true;
                        }
                        return false;
                    });

                    sum = filteredRows
                        .map((r) => parseFloat(r[column.key]) || 0)
                        .reduce((total, item) => total + item, 0);
                } else {
                    sum = rows
                        .map((r) => parseFloat(r[column.key]) || 0)
                        .reduce((total, item) => total + item, 0);
                }

                sumResult[column.key] = sum;
            } else {
                sumResult[column.key] = "";
            }
            return sumResult;
        }, {});

        groupResult.push(groupSum);
        return groupResult;
    }, []);

const convertToMobileResult = (desktopResult, columns, t) => {
    const sumColumns = columns.filter(
        (c) => c.footer && c.footer.sum && !c.hiddenMobile,
    );

    return desktopResult.reduce((result, row) => {
        sumColumns.forEach((sc) => {
            const rowClone = { ...row };
            rowClone[Object.keys(rowClone)[0]] =
                t.sum + ` ${sc.title.toLowerCase()}`;
            const resetColumns = sumColumns.filter((x) => x.key !== sc.key);
            resetColumns.forEach((rk) => {
                rowClone[rk.key] = "";
            });
            result.push(rowClone);
        });
        return result;
    }, []);
};

export const getFooterRows = (columns, rows, isMobileMode, t) => {
    if (columns.filter((c) => c.footer).length < 1) return [];
    const result = sumRows(columns, groupRows(columns, rows), t);
    return isMobileMode ? convertToMobileResult(result, columns, t) : result;
};
